import React from "react";
import AvishaHeadshot from "../../assets/images/Avisha_headshot.png";

export default function FeelingProud() {
  return (
    <img
      src={AvishaHeadshot}
      alt="Avisha Lad headshot"
      className="greeting-headshot"
    />
  );
}
